import React from "react";
import ApiResponse from "sr/models/ApiResponse";
import { get } from "sr/utils/axios";

export const getUnreadMessageCount = async (queryParams) => {
    try {
  return await get<ApiResponse<[]>>(`/chatmessage/chats?${queryParams}`).then((res)=> {
    if(res?.success===true){
        return res
    }
    else {
        return null
    }
  })
}
catch(e){

}
};
